import { useToast } from "@/hooks/use-toast";
import { CollectionFormTypes, TestimonialFormTypes } from "./schema";

export const validateReviewForm = (
  data: CollectionFormTypes,
  values: TestimonialFormTypes,
  toaster: ReturnType<typeof useToast>,
  formData: FormData,
) => {
  if (!formData.get("avatar") && data.formFields.photo.required) {
    toaster.toast({ description: "Please upload a profile photo" });
    return false;
  }
  if (!values.customer.title && data.formFields.headline.required) {
    toaster.toast({
      description: "Please enter a headline or description about yourself",
    });
    return false;
  }
  if (!values.customer.name && data.formFields.name.required) {
    toaster.toast({ description: "Please enter your name" });
    return false;
  }
  if (!values.customer.email && data.formFields.email.required) {
    toaster.toast({ description: "Please enter your email" });
    return false;
  }
  if (!values.customer.url && data.formFields.link.required) {
    toaster.toast({
      description: "Please enter your website URL or any relevant links",
    });
    return false;
  }
  return true;
};
